/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RegisteredMemberInfoDTO } from './RegisteredMemberInfoDTO';
import {
    RegisteredMemberInfoDTOFromJSON,
    RegisteredMemberInfoDTOFromJSONTyped,
    RegisteredMemberInfoDTOToJSON,
} from './RegisteredMemberInfoDTO';
import type { OrganizationRoleDTO } from './OrganizationRoleDTO';
import {
    OrganizationRoleDTOFromJSON,
    OrganizationRoleDTOFromJSONTyped,
    OrganizationRoleDTOToJSON,
} from './OrganizationRoleDTO';
import type { OrganizationInvitationDTO } from './OrganizationInvitationDTO';
import {
    OrganizationInvitationDTOFromJSON,
    OrganizationInvitationDTOFromJSONTyped,
    OrganizationInvitationDTOToJSON,
} from './OrganizationInvitationDTO';

/**
 * 
 * @export
 * @interface OrganizationMemberDTO
 */
export interface OrganizationMemberDTO {
    /**
     * 
     * @type {RegisteredMemberInfoDTO}
     * @memberof OrganizationMemberDTO
     */
    registeredMemberInfo?: RegisteredMemberInfoDTO;
    /**
     * 
     * @type {OrganizationRoleDTO}
     * @memberof OrganizationMemberDTO
     */
    role: OrganizationRoleDTO;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationMemberDTO
     */
    editableRole: boolean;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationMemberDTO
     */
    joinedAt?: Date;
    /**
     * 
     * @type {OrganizationInvitationDTO}
     * @memberof OrganizationMemberDTO
     */
    invitationInfo?: OrganizationInvitationDTO;
    /**
     * 
     * @type {number}
     * @memberof OrganizationMemberDTO
     */
    numberOfProjects?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationMemberDTO
     */
    totalNumberOfProjects?: number;
}



/**
 * Check if a given object implements the OrganizationMemberDTO interface.
 */
export function instanceOfOrganizationMemberDTO(value: object): value is OrganizationMemberDTO {
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('editableRole' in value) || value['editableRole'] === undefined) return false;
    return true;
}

export function OrganizationMemberDTOFromJSON(json: any): OrganizationMemberDTO {
    return OrganizationMemberDTOFromJSONTyped(json, false);
}

export function OrganizationMemberDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationMemberDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'registeredMemberInfo': json['registeredMemberInfo'] == null ? undefined : RegisteredMemberInfoDTOFromJSON(json['registeredMemberInfo']),
        'role': OrganizationRoleDTOFromJSON(json['role']),
        'editableRole': json['editableRole'],
        'joinedAt': json['joinedAt'] == null ? undefined : (new Date(json['joinedAt'])),
        'invitationInfo': json['invitationInfo'] == null ? undefined : OrganizationInvitationDTOFromJSON(json['invitationInfo']),
        'numberOfProjects': json['numberOfProjects'] == null ? undefined : json['numberOfProjects'],
        'totalNumberOfProjects': json['totalNumberOfProjects'] == null ? undefined : json['totalNumberOfProjects'],
    };
}

export function OrganizationMemberDTOToJSON(value?: OrganizationMemberDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'registeredMemberInfo': RegisteredMemberInfoDTOToJSON(value['registeredMemberInfo']),
        'role': OrganizationRoleDTOToJSON(value['role']),
        'editableRole': value['editableRole'],
        'joinedAt': value['joinedAt'] == null ? undefined : ((value['joinedAt']).toISOString()),
        'invitationInfo': OrganizationInvitationDTOToJSON(value['invitationInfo']),
        'numberOfProjects': value['numberOfProjects'],
        'totalNumberOfProjects': value['totalNumberOfProjects'],
    };
}

